import { useTheme } from '@shopify/restyle';

import { Column } from '../box';
import { Button } from '../button';
import type { Theme } from 'app/shopify';

export interface RadioProps {
  onPress?: () => void;
  checked?: boolean;
  color?: keyof Theme['colors'];
  colorInactive?: keyof Theme['colors'];
  height?: number;
  width?: number;
}

export function Radio({
  onPress,
  checked,
  color = 'icon.brand',
  colorInactive = 'icon.tertiary',
  height,
  width,
}: RadioProps) {
  const theme = useTheme<Theme>();

  return (
    <Button
      {...{ onPress }}
      alignItems="center"
      aspectRatio={1}
      height={height ?? 20}
      width={width ?? 20}
      justifyContent="center"
      style={{
        borderColor: checked ? theme.colors[color] : theme.colors[colorInactive],
        borderRadius: height ? height / 2 : width ? width / 2 : 10,
        borderWidth: 1,
      }}
      variant="plain"
    >
      {checked ? <Column aspectRatio={1} backgroundColor={color} borderRadius="radius.sm" height={10} /> : null}
    </Button>
  );
}
